import React from "react";

export const FilterSvgPickerContext = React.createContext<
  (() => Promise<string | null>) | undefined
>(undefined);
